import React from "react";
import { cn } from "src/lib/utils";

function FormSelect({ label, name, value, options = [], onChange, error, className }) {
	return (
		<div className={cn("formItem", className)}>
			<label htmlFor={name}>{label}</label>
			<select
				id={name}
				name={name}
				value={value}
				onChange={(e) => {
					const selectedValue = e.target.value;
					const selectedOption = options.find((option) => option.value === selectedValue);
					onChange(selectedOption || { value: "", label: "" }); // Prevent undefined
				}}
				className={error ? "inputError" : ""}
			>
				<option value="" disabled>
					Select {label}
				</option>
				{options.length > 0 ? (
					options.map((option, index) => (
						<option key={index} value={option.value}>
							{option.label}
						</option>
					))
				) : (
					<option disabled>No options available</option>
				)}
			</select>
			{error && <p className="errorMsg">{error}</p>}
		</div>
	);
}

export default FormSelect;
